<template>
  <div class="region">
    <el-cascader :options="regionData" :props="props" clearable @change="change" placeholder="请选择区域"></el-cascader>
  </div>
</template>

<script>
// 城市选择
export default {
  name: 'region',
  data() {
    return {
      props: {
        label: 'name',
        value: 'code',
        checkStrictly: true
      },
      regionData: []
    };
  },
  created() {
    // 获取城市数据
    this.$axios('./region/region.json').then(res => {
      this.regionData = res.data;
    });
  },
  methods: {
    change(val) {
      this.$emit('input', val);
      this.$emit('change', val);
    }
  }
};
</script>
